import { FC, useEffect, useState } from "react";

import classes from "./FinishedBattle.module.css";
import Button from "../UI/Button";
import { BattleModelDocument } from "../image/Image";
import axios from "axios";
import { useSelector } from "react-redux";
import { userState } from "../../store/user";

interface Props extends BattleModelDocument {
  currentUserIndex: number;
  refreshUserBattles: () => Promise<void>;
  setPopupImage: React.Dispatch<React.SetStateAction<string>>;
}

const FinishedBattle: FC<Props> = ({
  _id,
  artwork1ID,
  artwork1Src,
  artwork2ID,
  artwork2Src,
  level,
  artwork1VotesCount,
  artwork2VotesCount,
  winnerArtworkID,
  winnerDecision,
  currentUserIndex,
  refreshUserBattles,
  topic,
  setPopupImage,
}) => {
  const API_URL = process.env.REACT_APP_API_URL;
  const user = useSelector(userState);
  const [isLoading, setIsLoading] = useState(false);
  const [updatedWinnerDecision, setUpdatedWinnerDecision] = useState("");
  const takeWin = async () => {
    setIsLoading(true);
    await axios
      .patch(
        `${API_URL}/battles/takewin/${_id.toString()}`,
        {},
        {
          withCredentials: true,
          headers: { Authorization: `Bearer ${user.sessionToken}` },
        }
      )
      .then((response) => {
        setUpdatedWinnerDecision(response.data.battle.winnerDecision);
        refreshUserBattles();
        setIsLoading(false);
      })
      .catch((error) => {
        console.log(error);
        setIsLoading(false);
      });
  };
  const nextLevel = async () => {
    setIsLoading(true);
    await axios
      .patch(
        `${API_URL}/battles/nextlevel/${_id.toString()}`,
        {},
        {
          withCredentials: true,
          headers: { Authorization: `Bearer ${user.sessionToken}` },
        }
      )
      .then((response) => {
        setUpdatedWinnerDecision(response.data.battle.winnerDecision);
        refreshUserBattles();
        setIsLoading(false);
      })
      .catch((error) => {
        console.log(error);
        setIsLoading(false);
      });
  };
  const win =
    (winnerArtworkID === artwork1ID && currentUserIndex === 0) ||
    (winnerArtworkID === artwork2ID && currentUserIndex === 1)
      ? true
      : false;
  // let winAmount = 0;
  // switch (level) {
  //   case 1:
  //     winAmount = 15;
  //     break;
  //   case 2:
  //     winAmount = 20;
  //     break;
  //   case 3:
  //     winAmount = 30;
  //     break;
  //   case 4:
  //     winAmount = 45;
  //     break;
  //   case 5:
  //     winAmount = 70;
  //     break;
  //   case 6:
  //     winAmount = 110;
  //     break;
  //   case 7:
  //     winAmount = 210;
  //     break;
  // }
  let loseAmount = 0;
  switch (level) {
    case 1:
      loseAmount = 0;
      break;
    case 2:
      loseAmount = 10;
      break;
    case 3:
      loseAmount = 25;
      break;
    case 4:
      loseAmount = 50;
      break;
    case 5:
      loseAmount = 90;
      break;
    case 6:
      loseAmount = 150;
      break;
    case 7:
      loseAmount = 250;
      break;
  }
  useEffect(() => {
    setUpdatedWinnerDecision(winnerDecision);
  }, []);
  console.log(updatedWinnerDecision);
  return (
    <div className={`${classes.votepair} ${classes.isResult}`}>
      <div className={classes.title}>
        <span className={classes.left}>
          <span>{topic ? topic.title : "That's Art Baby!"}</span>
        </span>
        <span className={classes.level}>
          Level <span className={classes.points}>{level}</span>
        </span>
      </div>
      {/* <div className={classes.info}>
        <div className={classes.level}>
          <div className={classes.rate}>
            <h2>Battle Level</h2>
            <div className={classes.points}>{level}</div>
          </div>
        </div>
        {win && updatedWinnerDecision === "pending" && (
          <div className={`${classes.result} ${classes.labelWin}`}>WIN</div>
        )}
        {win &&
          updatedWinnerDecision &&
          updatedWinnerDecision === "takeWin" && (
            <div className={`${classes.result} ${classes.labelWin}`}>
              +{winAmount} 🌕
            </div>
          )}
        {win &&
          updatedWinnerDecision &&
          updatedWinnerDecision === "levelUp" && (
            <div className={`${classes.result} ${classes.labelWin}`}>🚀</div>
          )}
        {win && updatedWinnerDecision && updatedWinnerDecision === "nft" && (
          <div className={`${classes.result} ${classes.labelWin}`}>NFT</div>
        )}
        {!win && (
          <div className={`${classes.result} ${classes.labelLose}`}>LOSE</div>
        )}
      </div> */}
      <div className={classes.images}>
        <div
          className={`${classes.img} ${!currentUserIndex ? classes.voted : ""}`}
          onClick={() => {
            if (currentUserIndex === 1) setPopupImage(artwork1ID);
          }}
        >
          {currentUserIndex === 1 && (
            <span className={classes.popupIcon}>
              <svg
                xmlns="http://www.w3.org/2000/svg"
                fillRule="evenodd"
                clipRule="evenodd"
                viewBox="0 0 509 511.54"
              >
                <path
                  fillRule="nonzero"
                  fill="#fff"
                  d="M447.19 347.03c0-17.06 13.85-30.91 30.91-30.91 17.05 0 30.9 13.85 30.9 30.91v87.82c0 21.08-8.63 40.29-22.51 54.18-13.88 13.88-33.09 22.51-54.18 22.51H76.69c-21.09 0-40.3-8.63-54.18-22.51C8.63 475.14 0 455.93 0 434.85V76.69c0-21.09 8.63-40.3 22.51-54.18C36.39 8.63 55.6 0 76.69 0h86.98c17.06 0 30.9 13.85 30.9 30.9 0 17.06-13.84 30.91-30.9 30.91H76.69c-4.07 0-7.82 1.69-10.51 4.37-2.68 2.69-4.37 6.44-4.37 10.51v358.16c0 4.06 1.69 7.82 4.37 10.5 2.69 2.68 6.44 4.38 10.51 4.38h355.62c4.07 0 7.82-1.7 10.51-4.38 2.68-2.68 4.37-6.44 4.37-10.5v-87.82zm0-243.56L308.15 244.28c-11.91 12.12-31.45 12.28-43.56.37-12.11-11.91-12.28-31.45-.37-43.56L401.77 61.81H309.7c-17.06 0-30.9-13.85-30.9-30.91 0-17.05 13.84-30.9 30.9-30.9h168.4C495.15 0 509 13.85 509 30.9v165.04c0 17.06-13.85 30.9-30.9 30.9-17.06 0-30.91-13.84-30.91-30.9v-92.47z"
                />
              </svg>
            </span>
          )}
          <img src={artwork1Src} alt="" />
          <div
            className={`${classes.score} ${
              artwork1VotesCount > artwork2VotesCount
                ? classes.win
                : classes.lose
            }`}
          >
            {artwork1VotesCount}
          </div>
        </div>
        <div
          className={`${classes.img} ${currentUserIndex ? classes.voted : ""}`}
          onClick={() => {
            if (currentUserIndex === 0) setPopupImage(artwork2ID || "");
          }}
        >
          {currentUserIndex === 0 && (
            <span className={classes.popupIcon}>
              <svg
                xmlns="http://www.w3.org/2000/svg"
                fillRule="evenodd"
                clipRule="evenodd"
                viewBox="0 0 509 511.54"
              >
                <path
                  fillRule="nonzero"
                  fill="#fff"
                  d="M447.19 347.03c0-17.06 13.85-30.91 30.91-30.91 17.05 0 30.9 13.85 30.9 30.91v87.82c0 21.08-8.63 40.29-22.51 54.18-13.88 13.88-33.09 22.51-54.18 22.51H76.69c-21.09 0-40.3-8.63-54.18-22.51C8.63 475.14 0 455.93 0 434.85V76.69c0-21.09 8.63-40.3 22.51-54.18C36.39 8.63 55.6 0 76.69 0h86.98c17.06 0 30.9 13.85 30.9 30.9 0 17.06-13.84 30.91-30.9 30.91H76.69c-4.07 0-7.82 1.69-10.51 4.37-2.68 2.69-4.37 6.44-4.37 10.51v358.16c0 4.06 1.69 7.82 4.37 10.5 2.69 2.68 6.44 4.38 10.51 4.38h355.62c4.07 0 7.82-1.7 10.51-4.38 2.68-2.68 4.37-6.44 4.37-10.5v-87.82zm0-243.56L308.15 244.28c-11.91 12.12-31.45 12.28-43.56.37-12.11-11.91-12.28-31.45-.37-43.56L401.77 61.81H309.7c-17.06 0-30.9-13.85-30.9-30.91 0-17.05 13.84-30.9 30.9-30.9h168.4C495.15 0 509 13.85 509 30.9v165.04c0 17.06-13.85 30.9-30.9 30.9-17.06 0-30.91-13.84-30.91-30.9v-92.47z"
                />
              </svg>
            </span>
          )}
          <img src={artwork2Src} alt="" />
          <div
            className={`${classes.score} ${
              artwork2VotesCount > artwork1VotesCount
                ? classes.win
                : classes.lose
            }`}
          >
            {artwork2VotesCount}
          </div>
        </div>
      </div>
      <div
        className={`${classes.results} ${classes.newResults} ${
          win ? classes.resultWin : classes.resultLose
        }`}
      >
        <div
          className={`${classes.winLose} ${
            win ? classes.labelWin : classes.labelLose
          }`}
        >
          {win ? `You won` : `You lose`}
        </div>
        <div className={classes.decision}>
          {win && (
            <div>
              {/* {win && updatedWinnerDecision === "pending" && (
                <div className={`${classes.result} ${classes.labelWin}`}>
                  WIN
                </div>
              )} */}
              {/* {win &&
                updatedWinnerDecision &&
                updatedWinnerDecision === "takeWin" && (
                  <div className={`${classes.result} ${classes.labelWin}`}>
                    +{winAmount} 🌕
                  </div>
                )} */}
              {win &&
                updatedWinnerDecision &&
                updatedWinnerDecision === "levelUp" && (
                  <div className={`${classes.result} ${classes.labelWin}`}>
                    🚀&nbsp; {level} &rarr; {level + 1}
                  </div>
                )}
              {win &&
                updatedWinnerDecision &&
                updatedWinnerDecision === "nft" && (
                  <div className={`${classes.result} ${classes.labelWin}`}>
                    NFT
                  </div>
                )}
            </div>
          )}
          {!win && level > 1 && (
            <div
              className={win ? classes.labelWin : classes.labelLose}
            >{`+${loseAmount} 🌕`}</div>
          )}
        </div>
      </div>
      {/* {win && updatedWinnerDecision === "pending" && (
        <div
          className={`${classes.results} ${
            win ? classes.resultWin : classes.resultLose
          }`}
        >
          <div className={classes.actions}>
            <Button
              secondary={true}
              label={`Take +${winAmount} 🌕`}
              disabled={isLoading}
              onClick={takeWin}
            />
            <span>or</span>
            <Button
              label="Next Level"
              disabled={isLoading}
              onClick={nextLevel}
            />
          </div>
        </div>
      )} */}
    </div>
  );
};

export default FinishedBattle;
